import { epoch, formatEpochAsDate, utc } from '../../util/datetime';
import type { IAssetFinanceProposalAmortizationSchedule } from './AssetFinanceProposalAmortizationSchedule.interface';

export default class AssetFinanceProposalAmortizationSchedule
  implements IAssetFinanceProposalAmortizationSchedule {
  repayment: number;
  isRepaymentEdited: boolean;
  beginningBalance: number;
  principalReduction: number;
  interestPaid: number;
  interestDeferred: number;
  endingBalance: number;
  paymentDate: number;

  getPaymentDate(timeZone, locale, localeFormat) {
    return formatEpochAsDate(this.timeStamp, timeZone, locale, localeFormat);
  }

  static build = (data: IAssetFinanceProposalAmortizationSchedule) =>
    new AssetFinanceProposalAmortizationSchedule(data);

  static blank = () => new AssetFinanceProposalAmortizationSchedule();

  /**
   * Constructor
   * @param {IAssetFinanceProposalAmortizationSchedule} data
   */
  constructor(data?: IAssetFinanceProposalAmortizationSchedule) {
    this.repayment = parseFloat(data?.repayment || 0);
    this.isRepaymentEdited = data?.isRepaymentEdited === true;
    this.beginningBalance = parseFloat(data?.beginningBalance || 0);
    this.principalReduction = parseFloat(data?.principalReduction || 0);
    this.interestPaid = parseFloat(data?.interestPaid || 0);
    this.interestDeferred = parseFloat(data?.interestDeferred || 0);
    this.endingBalance = parseFloat(data?.endingBalance || 0);
    this.paymentDate = epoch(utc(data?.paymentDate));
  }
}
